module.exports = __webpack_public_path__ + "public/img/yibiaopan_lv_2.23259096.png";